import { accrualsFormats } from 'src/helpers/formatting';
import { hasValue } from 'swipeclock-frontend';

export const completeTransformer = (payPeriods, end) => {
  const { periods } = payPeriods;
  const payPeriod = periods.filter(
    (period) =>
      accrualsFormats.formatDateForURL(period.endDate) ===
      accrualsFormats.formatDateForURL(end)
  );

  return hasValue(payPeriod);
};
